import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  Box,
} from "@mui/material";
import { useQuery } from "react-query";
import { getLabDetails } from "./services"; // Assuming this returns the full array
import CustomTableBody from "../../../utilis/component/CustomTableBody"; // Keep this
import CheckIcon from "@mui/icons-material/Check";
import { LabDetailsType } from "./types";
import CloseIcon from "@mui/icons-material/Close";
import UploadedFileList from "../../../MainDashboard/Lab/LabDetails/UploadedFileList";
import moment from "moment";
// import WarningIcon from "@mui/icons-material/Warning";
// import ErrorIcon from "@mui/icons-material/Error";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import RemoveIcon from "@mui/icons-material/Remove";
// const createIcon = (
//   IconComponent: React.ElementType,
//   color: "error" | "warning" | "success" | "primary" | "info" | "inherit"
// ) => <IconComponent color={color} fontSize="inherit" />;
// import WarningIcon from "@mui/icons-material/Warning";
// import ErrorIcon from "@mui/icons-material/Error";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import RemoveIcon from "@mui/icons-material/Remove";
// const createIcon = (
//   IconComponent: React.ElementType,
//   color: "error" | "warning" | "success" | "primary" | "info" | "inherit"
// ) => <IconComponent color={color} fontSize="inherit" />;

// const ABNORMAL_FLAG_DETAILS = {
//   "<": {
//     name: "Below Scale Low",
//     hex: "#C70039",
//     icon: createIcon(ErrorIcon, "error"),
//   },
//   ">": {
//     name: "Above Scale High",
//     hex: "#C70039",
//     icon: createIcon(ErrorIcon, "error"),
//   },
//   HH: {
//     name: "Panic High",
//     hex: "#C70039",
//     icon: createIcon(ErrorIcon, "error"),
//   },
//   LL: {
//     name: "Panic Low",
//     hex: "#C70039",
//     icon: createIcon(ErrorIcon, "error"),
//   },
//   AA: {
//     name: "Very Abnormal",
//     hex: "#C70039",
//     icon: createIcon(ErrorIcon, "error"),
//   },
//   R: {
//     name: "Resistant",
//     hex: "#DC3545",
//     icon: createIcon(CloseIcon, "error"),
//   },
//   H: {
//     name: "Above Normal",
//     hex: "#FF8C00",
//     icon: createIcon(KeyboardArrowUpIcon, "warning"),
//   },
//   L: {
//     name: "Below Normal",
//     hex: "#FF8C00",
//     icon: createIcon(KeyboardArrowDownIcon, "warning"),
//   },
//   A: {
//     name: "Abnormal",
//     hex: "#FF8C00",
//     icon: createIcon(WarningIcon, "warning"),
//   },
//   I: {
//     name: "Intermediate",
//     hex: "#FFC107",
//     icon: createIcon(WarningIcon, "warning"),
//   },
//   MS: {
//     name: "Mod. Susceptible",
//     hex: "#FFC107",
//     icon: createIcon(WarningIcon, "warning"),
//   },
//   U: {
//     name: "Significant Change Up",
//     hex: "#FFD700",
//     icon: createIcon(KeyboardArrowUpIcon, "warning"),
//   },
//   D: {
//     name: "Significant Change Down",
//     hex: "#FFD700",
//     icon: createIcon(KeyboardArrowDownIcon, "warning"),
//   },
//   W: {
//     name: "Worse",
//     hex: "#FFD700",
//     icon: createIcon(WarningIcon, "warning"),
//   },
//   B: {
//     name: "Better",
//     hex: "#6B8E23",
//     icon: createIcon(CheckCircleIcon, "success"),
//   }, // Using a positive icon for 'Better'
//   S: {
//     name: "Susceptible",
//     hex: "#28A745",
//     icon: createIcon(CheckCircleIcon, "success"),
//   },
//   VS: {
//     name: "Very Susceptible",
//     hex: "#28A745",
//     icon: createIcon(CheckCircleIcon, "success"),
//   },
//   N: {
//     name: "Normal",
//     hex: "#212529",
//     icon: createIcon(RemoveIcon, "inherit"),
//   },
//   null: {
//     name: "N/A",
//     hex: "#212529",
//     icon: createIcon(RemoveIcon, "inherit"),
//   },
// };
// const ABNORMAL_FLAG_DETAILS = {
//   "<": {
//     name: "Below Scale Low",
//     hex: "#C70039",
//     icon: createIcon(ErrorIcon, "error"),
//   },
//   ">": {
//     name: "Above Scale High",
//     hex: "#C70039",
//     icon: createIcon(ErrorIcon, "error"),
//   },
//   HH: {
//     name: "Panic High",
//     hex: "#C70039",
//     icon: createIcon(ErrorIcon, "error"),
//   },
//   LL: {
//     name: "Panic Low",
//     hex: "#C70039",
//     icon: createIcon(ErrorIcon, "error"),
//   },
//   AA: {
//     name: "Very Abnormal",
//     hex: "#C70039",
//     icon: createIcon(ErrorIcon, "error"),
//   },
//   R: {
//     name: "Resistant",
//     hex: "#DC3545",
//     icon: createIcon(CloseIcon, "error"),
//   },
//   H: {
//     name: "Above Normal",
//     hex: "#FF8C00",
//     icon: createIcon(KeyboardArrowUpIcon, "warning"),
//   },
//   L: {
//     name: "Below Normal",
//     hex: "#FF8C00",
//     icon: createIcon(KeyboardArrowDownIcon, "warning"),
//   },
//   A: {
//     name: "Abnormal",
//     hex: "#FF8C00",
//     icon: createIcon(WarningIcon, "warning"),
//   },
//   I: {
//     name: "Intermediate",
//     hex: "#FFC107",
//     icon: createIcon(WarningIcon, "warning"),
//   },
//   MS: {
//     name: "Mod. Susceptible",
//     hex: "#FFC107",
//     icon: createIcon(WarningIcon, "warning"),
//   },
//   U: {
//     name: "Significant Change Up",
//     hex: "#FFD700",
//     icon: createIcon(KeyboardArrowUpIcon, "warning"),
//   },
//   D: {
//     name: "Significant Change Down",
//     hex: "#FFD700",
//     icon: createIcon(KeyboardArrowDownIcon, "warning"),
//   },
//   W: {
//     name: "Worse",
//     hex: "#FFD700",
//     icon: createIcon(WarningIcon, "warning"),
//   },
//   B: {
//     name: "Better",
//     hex: "#6B8E23",
//     icon: createIcon(CheckCircleIcon, "success"),
//   }, // Using a positive icon for 'Better'
//   S: {
//     name: "Susceptible",
//     hex: "#28A745",
//     icon: createIcon(CheckCircleIcon, "success"),
//   },
//   VS: {
//     name: "Very Susceptible",
//     hex: "#28A745",
//     icon: createIcon(CheckCircleIcon, "success"),
//   },
//   N: {
//     name: "Normal",
//     hex: "#212529",
//     icon: createIcon(RemoveIcon, "inherit"),
//   },
//   null: {
//     name: "N/A",
//     hex: "#212529",
//     icon: createIcon(RemoveIcon, "inherit"),
//   },
// };

// const getFlagDetails = (code: string | null) => {
//   const codeString = code === null || code === "null" ? "null" : code;
//   return (
//     ABNORMAL_FLAG_DETAILS[codeString as keyof typeof ABNORMAL_FLAG_DETAILS] ||
//     ABNORMAL_FLAG_DETAILS["null"]
//   );
// };
// const getFlagDetails = (code: string | null) => {
//   const codeString = code === null || code === "null" ? "null" : code;
//   return (
//     ABNORMAL_FLAG_DETAILS[codeString as keyof typeof ABNORMAL_FLAG_DETAILS] ||
//     ABNORMAL_FLAG_DETAILS["null"]
//   );
// };

function LabDetails({ id }: { id: number }) {
  const { data, isLoading } = useQuery(
    [`Labdetailslist${id}`, id],
    async () => getLabDetails(id),
    { refetchOnWindowFocus: false }
  );

  const labResults: Array<{
    testName: string;
    labId: number;
    data: LabDetailsType[];
  }> = data?.response || [];

  // const getStatusLabel = (status: "P" | "F" | "C") => {
  //   switch (status) {
  //     case "P":
  //       return (
  //         <Typography color="primary" variant="caption">
  //           Preliminary
  //         </Typography>
  //       );
  //     case "F":
  //       return (
  //         <Typography color="success" variant="caption">
  //           Final
  //         </Typography>
  //       );
  //     case "C":
  //       return (
  //         <Typography color="error" variant="caption">
  //           Corrected
  //         </Typography>
  //       );
  //     default:
  //       return "-";
  //   }
  // };

  return (
    <>
      <Table
        sx={{
          border: "1px solid #ccc",
          "& .MuiTableCell-root": { border: "1px solid #ccc" },
        }}
        size="small"
        className="border"
        aria-label="lab results table"
      >
        <TableHead>
          <TableRow>
            {heading.map((item) => (
              <TableCell key={item} style={{ fontWeight: "bold" }}>
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <CustomTableBody
          alert={"No lab results found."}
          dataLoading={isLoading}
          isData={Boolean(labResults.length)}
          totalSpan={{ col: heading.length, row: 5 }}
        >
          {labResults.map((testGroup, groupIndex) => {
            // Iterate through the inner 'data' array for each testGroup
            return testGroup.data.map((item, dataIndex) => {
              // const flagDetails = getFlagDetails(item.abnormalFlagName);
              const isFirstRow = dataIndex === 0; // Check if this is the first row of the group

              return (
                <TableRow key={`${groupIndex}-${dataIndex}`}>
                  {/* TEST NAME: Only show on the first row of the group and span down */}
                  {isFirstRow && (
                    <>
                      <TableCell align="center" rowSpan={testGroup.data.length}>
                        {groupIndex + 1}
                      </TableCell>
                      <TableCell rowSpan={testGroup.data.length}>
                        {testGroup.testName}
                      </TableCell>
                    </>
                  )}

                  <TableCell>
                    {item.resultName || item.fieldName || "-"}
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontWeight: "bold" }}
                    >
                      {item.fieldValue || "-"}
                    </Typography>
                  </TableCell>

                  <TableCell>{item.fieldUnit || "-"}</TableCell>
                  <TableCell>{item.fieldRange || "-"}</TableCell>

                  <TableCell>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      {/* {flagDetails.icon} */}
                      <Typography variant="caption" color="text.secondary">
                        {/* {flagDetails.name} */}
                        {item.abnormalFlagName}
                      </Typography>
                    </Box>
                  </TableCell>

                  <TableCell align="center">
                    {item.isPerformed ? (
                      <CheckIcon color="success" fontSize="small" />
                    ) : (
                      <CloseIcon color="error" fontSize="small" />
                    )}
                  </TableCell>

                  {/* <TableCell align="center">
                    {getStatusLabel(item.resultStatus)}
                  </TableCell> */}

                  <TableCell>
                    {item?.createdDate
                      ? moment(item?.createdDate).format("DD-MM-YYYY hh:ss A")
                      : ""}
                  </TableCell>
                  {isFirstRow && (
                    <TableCell
                      rowSpan={testGroup.data.length}
                      align="center"
                      style={{ verticalAlign: "middle" }}
                    >
                      <UploadedFileList labId={testGroup.labId} />
                    </TableCell>
                  )}
                </TableRow>
              );
            });
          })}
        </CustomTableBody>
      </Table>
    </>
  );
}

export default LabDetails;

const heading = [
  "Sl no",
  "Test Name",
  "Test",
  "Result",
  "Unit",
  "Ref. Range",
  "Abnormal Flag", // NEW COLUMN
  "Performed",
  // "Status",
  "Created Date",
  "Action",
];
